import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const updateEmail = (newEmail: string) => {
    return RESTClient.postAuthenticatedObservable('v2/email/change', {
        newEmail,
    });
};
